import type { ReactNode } from "react";

export const MULTI_STEP_FORM_SCROLL_CONTAINER = "MULTI_STEP_FORM_SCROLL_CONTAINER";
import { FullScreenDialog } from "../../shared/FullScreenDialog";

type MultiStepFormDialogProps = { onClose?: () => void; children: ReactNode };
export const MultiStepFormDialog = ({ onClose, children }: MultiStepFormDialogProps) => {
  return (
    <FullScreenDialog onClose={onClose} paperId={MULTI_STEP_FORM_SCROLL_CONTAINER} transitionDuration={0}>
      {children}
    </FullScreenDialog>
  );
};
